import React from "react";
import { graphql, useStaticQuery, Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import roads from "../../images/park_map_roads.svg"
import droppin from "../../images/map_pin.svg"
import Prose from "../utility/prose";

const HeroNavigation = (config) => {
    const heroConfig = JSON.parse(config.config)
    const data = useStaticQuery(graphql`
        query {
            background: file(relativePath: {eq: "hamed-taha-1_K74KTKke8-unsplash.jpg"}) {
                id
                childImageSharp {
                    gatsbyImageData(
                        width: 2048
                        placeholder: BLURRED
                        formats: [AUTO, WEBP, AVIF]
                    )                    
                }
            }
        }
  `)
  console.log(heroConfig)
    

    return (
        <div className="mx-auto mb-14 h-72 relative">
            <GatsbyImage className="rounded-3xl h-72 absolute" imgClassName="" image={data.background.childImageSharp.gatsbyImageData} alt="" />
            <div className="absolute top-0 text-white grid grid-cols-3 content-center h-72 w-full">
                { heroConfig.map(node => (
                    <a className="bg-[rgba(0,0,0,0.4)] backdrop-blur-sm w-32 md:w-48 h-32 md:h-48 p-8 flex flex-col text-center justify-center border-white border-2 rounded-full mx-auto shadow-xl hover:shadow-2xl hover:-translate-y-2 transition-all hover:border-yellow-200 text-xs lg:text-base font-medium leading-tight" href={node.url}><div>
                        <img className="w-8 md:w-16 mx-auto" src={node.icon_url} alt="icon" />
                        {node.label}
                    </div>
                    </a>
                ))}
            </div>
        </div>
    )
}

export default HeroNavigation